import { observer } from "mobx-react-lite"
import React from "react"
import { Checkbox } from "@mantine/core"
import { courseStore } from "../../app/store"
import { CourseService } from "../../app/services"

export const CoursePublishedCheckbox = observer(function CoursePublishedCheckbox() {
  const { isLoading, searchParams: { publishedOnly } } = courseStore

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    CourseService.setSearchParam("publishedOnly", event.currentTarget.checked)
  }

  return <Checkbox
    radius="md"
    label="Только опубликованные"
    checked={publishedOnly}
    onChange={onChange}
    disabled={isLoading}
  />
})
